const state = {
  showConfirmModal: false,
  modalCloseConfirmed: false,
}

const getters = {
  menu(state, getters, rootState, rootGetters) {
    const menuItems = []

    if (rootGetters['me/showProductDetails']) {
      menuItems.push({
        title: 'Dashboard',
        path: '/',
        icon: 's-data',
        menu: 'dashboard',
      })
    }

    if (rootGetters['me/showUsersList']) {
      menuItems.push({
        title: 'Users',
        path: '/users',
        icon: 'user',
        menu: 'users',
      })
    }

    if (rootGetters['me/showProvidersList']) {
      menuItems.push({
        title: 'Providers',
        path: '/providers',
        icon: 'tickets',
        menu: 'providers',
      })
    }

    if (rootGetters['me/showProductsList']) {
      menuItems.push({
        title: 'Products',
        path: '/products',
        icon: 'goods',
        menu: 'products',
      })
    }

    if (rootGetters['me/showCategoriesList']) {
      menuItems.push({
        title: 'Product Categories',
        path: '/categories',
        icon: 'files',
        menu: 'categories',
      })
    }

    if (rootGetters['me/canReadApiKey']) {
      menuItems.push({
        title: 'API Keys',
        path: '/api-keys',
        icon: 'key',
        menu: 'api-keys',
      })
    }

    if (rootGetters['me/canSearchApiLog']) {
      menuItems.push({
        title: 'Logs',
        path: '/logs',
        icon: 'link',
        menu: 'logs',
      })
    }

    return menuItems
  },
  showConfirmModal: state => state.showConfirmModal,
  modalCloseConfirmed: state => state.modalCloseConfirmed,
}

const mutations = {
  TOGGLE_CONFIRM_MODAL: (state, { show, confirmed = false }) => {
    state.showConfirmModal = show
    state.modalCloseConfirmed = confirmed
  },
}

const actions = {
  TOGGLE_CONFIRM_MODAL({ commit }, payload) {
    commit('TOGGLE_CONFIRM_MODAL', payload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
